import {cn} from '@chekinapp/ui';

export const TOP_BAR_GLASS_CLASS = cn(
  'bg-[var(--top-bar-fallback-bg)]',
  'supports-[backdrop-filter]:bg-[var(--top-bar-bg)]',
  'supports-[backdrop-filter]:backdrop-blur-[var(--top-bar-blur)]',
  'supports-[backdrop-filter]:backdrop-saturate-[var(--top-bar-saturate)]',
);
